<ion-toggle #toggle [checked]="active" (ionChange)="ionChanged(toggle)" (click)="stopClick($event)"></ion-toggle>